import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import Summary from "../../../ui/Summary";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import { validateMaxlength } from "../../../../utils/validate";

const SearchForm = ({ setSearchCondition }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setSearchCondition(data);
  };
  //検索条件リセット
  const resetCondition = () => {
    setValue("name", "");
  };

  return (
    <details open>
      <Summary />
      <form onSubmit={handleSubmit(onSubmit)}>
        <SearchCondition title="管理ユーザーを絞り込む">
          <table>
            <tr>
              <TextField
                register={register}
                name="name"
                errors={errors}
                label="名前"
                placeholder="名前"
                validation={{
                  ...validateMaxlength(100),
                }}
              ></TextField>
            </tr>
          </table>

          {errors.exampleRequired && <span>This field is required</span>}
        </SearchCondition>
        <div className={styles.buttonbox}>
          <Button type="submit" styleType="search">
            検索
          </Button>
          <Button
            type="button"
            styleType="back"
            onClick={() => resetCondition()}
          >
            条件クリア
          </Button>
        </div>
      </form>
    </details>
  );
};

export default SearchForm;
